/* eslint-disable @typescript-eslint/naming-convention */

export type IntegrationConfig = {
  autoPublishOnApprove: boolean
}

export const IntegrationConfigurations = {
  test_content_type: {
    autoPublishOnApprove: false,
  },
  data_ingestion_column_maps: {
    autoPublishOnApprove: true,
  },
  connect_api_key: {
    autoPublishOnApprove: true,
  },
  yoda_rules: {
    autoPublishOnApprove: false,
  },
  fulfillment_events: {
    autoPublishOnApprove: true,
  },
  massops: {
    autoPublishOnApprove: false,
  },
  /*
   * INTEGRATION DEVS: Add new content types here
   */
} as const satisfies { [x: string]: IntegrationConfig }

export type ContentTypes = keyof typeof IntegrationConfigurations
